import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/logos/poster.png")